import { Utils } from 'common';
import React, { Component } from 'react';

const { Session } = Utils;

export default class NSACancellation extends Component {
	render() {
		const contactNumber = Util.getFraudNumber();

		return (
			<div
				className="cancel-account-nsa-cancellation"
				data-qa="nsa-cancel-msg"
				{...{ dataqa: 'nsa-cancel-msg' }}
			>
				<h1 className="primary-header">Please give us a call</h1>
				<p>
					Due to the nature of the account, we are unable to complete the
					request.
				</p>
				<p>
					In order to proceed with your cancellation, please call us at{' '}
					{contactNumber} between hours of 6AM - 6PM PST.
				</p>
			</div>
		);
	}
}
